import { Space } from "antd";
import React from "react";
import "./styles.scss";

const PrivacyPolicy = () => {
  return (
    <section className="privacy-policy-content-container">
      <Space direction="vertical">
        <div className="content-heading-text">Privacy Policy</div>
        <div className="colored-text">Effective Date: 25.11.2024</div>
        <div className="content-text">
          Welcome to [SHIFTEDPIXEL]. Your privacy is important to us. This
          Privacy Policy explains how we handle and protect the information you
          provide when using all our games.
        </div>
        <div className="content-heading-text">Information we collect</div>
        <div className="content-text">
          We do not collect personal data or require user authentication.
          However, we use Firebase Analytics to collect anonymous data to help
          us improve our game.
        </div>
        <div className="content-text">
          Welcome to [SHIFTEDPIXEL]. Your privacy is important to us. This
          Privacy Policy explains how we handle and protect the information you
          provide when using all our games.
          <div className="content-sub-heading">This data includes:</div>
          <ul>
            <li>Device information (e.g., device type, operating system).</li>
            <li>
              Game performance metrics (e.g., crash reports, usage statistics).
            </li>
            <li>Non-identifiable usage trends.</li>
          </ul>
          <p>
            This information cannot be used to identify you personally and is
            solely used to enhance your gaming experience.
          </p>
        </div>
        <div className="content-heading-text">In-App Purchases</div>
        <div className="content-text">
          Our game includes third-party ads. These ad networks may use
          technologies like cookies to deliver tailored advertisements. We
          recommend reviewing the privacy policies of these ad networks for more
          information about their practices. Following is the list of ad
          networks we use:
          <ul>
            <li>AppLovin.</li>
            <li>AdMob</li>
            <li>Unity Ads</li>
          </ul>
        </div>
        <div className="content-heading-text">How We Use Collected Data</div>
        <div className="content-text">
          The anonymous data we collect is used to:
          <ul>
            <li>Improve game functionality and performance.</li>
            <li>Identify and fix bugs or crashes.</li>
            <li>Analyze gameplay trends to enhance the user experience.</li>
          </ul>
        </div>
        <div className="content-heading-text">Third-Party Services</div>
        <div className="content-text">
          We use the following third-party services in our game:
          <ul>
            <li>Improve game functionality and performance.</li>
            <li>Identify and fix bugs or crashes</li>
            <li>Analyze gameplay trends to enhance the user experience.</li>
          </ul>
        </div>
        <div className="content-heading-text">Third-Party Services</div>
        <div className="content-text">
          Our game is intended for general audiences and does not knowingly
          collect personal data from children. If you believe your child has
          provided personal information, please contact us, and we will promptly
          delete it.
        </div>
        <div className="content-heading-text">Your Consent</div>
        <div className="content-text">
          By playing our game, you consent to this Privacy Policy and the use of
          anonymous data as described.
        </div>
        <div className="content-heading-text">Changes to This Policy</div>
        <div className="content-text">
          We may update this Privacy Policy from time to time. Any changes will
          be reflected on this page, and we encourage you to review it
          periodically.
        </div>
        <div className="content-heading-text">Contact Us</div>
        <div className="content-text">
          If you have any questions about this Privacy Policy, please contact us
          at:
          <div>
            Email:{" "}
            <a href="mailto:contact@shiftedpixel.io">contact@shiftedpixel.io</a>
          </div>
          {/* <div>
            Website:{" "}
            <a href="/waqasyounis.com/shifted-pixel" target="_blank">
              shifted-pixel
            </a>
          </div> */}
        </div>
      </Space>
    </section>
  );
};

export default PrivacyPolicy;
